import React, { useState, useContext } from 'react';

import { useMutation } from '@apollo/client';
import { useFetch } from '@xingternal/hops';

import MaltFileUpload from '@xingternal/malt-file-upload';

import { uploadFile } from '../../utils';
import { ErrorContext } from '@xingternal/pages-page-error';

import UPLOAD_REQUEST_MUTATION from './UploadRequestMutation.graphql';

import styles from './FileUpload.css';

type FileUploadProps = {
  disableUpload?: boolean;
  children: any;
  onChange: () => void;
  onError: () => void;
  onSuccess: (fileData: string, file: string) => void;
};

const FileUpload = ({
  disableUpload,
  children,
  onChange,
  onSuccess,
  onError,
}: FileUploadProps) => {
  const { showError } = useContext(ErrorContext);
  const [resetCompontKey, setResetComponentKey] = useState(0);

  const fetch = useFetch();
  const [uploadRequest] = useMutation(UPLOAD_REQUEST_MUTATION);

  const upload = async (file: any) => {
    const fileBlob: any = {
      blob: file[0],
    };

    const fileData = await uploadFile(fileBlob, uploadRequest, fetch);

    if (!fileData?.id) {
      showError({
        message: 'EP_GENERAL_FEEDBACK_ERROR',
        error: fileData?.error,
      });
      onError();
    } else {
      await onSuccess(fileData.id, file[0].name);
    }
    setResetComponentKey(resetCompontKey + 1);
  };

  const handleUpload = (file: any) => {
    if (file[0].size > 100000000 || file[0].type !== 'application/pdf') {
      showError({
        message: 'EP_FILE_SIZE_FORMAT_ERROR',
      });
      setResetComponentKey(resetCompontKey + 1);
    } else {
      onChange();
      upload(file);
    }
  };

  return disableUpload ? (
    children
  ) : (
    <>
      <MaltFileUpload
        key={resetCompontKey}
        name="example-upload"
        maxSize={300000}
        onPreview={(e: any) => handleUpload(e)}
        accept=".pdf"
        className={styles.fileUploadButton}
      >
        {children}
      </MaltFileUpload>
    </>
  );
};

export default FileUpload;
